export default __webpack_public_path__ + "static/media/KAIROS_ALPHA_inner.ab0360e6.jpg";